// eslint-disable-next-line import/no-unresolved
import { ValidationRule, ValidationValueMessage } from 'react-hook-form/dist/types/validator';

export const isRuleMessage = (rule: ValidationRule): rule is ValidationValueMessage => (
  Object.prototype.hasOwnProperty.call(rule, 'message')
);
